import { ContractStage } from '../../../../models/Entities/Contracts/ContractStage';
import { ErrorType } from '../../../../models/HttpError';


// stores
import * as ContractStageStore from '../../../../redux/middleware/ContractStageMiddleware';
import * as ContractStageCycleStore from '../../../../redux/middleware/ContractStageCycleMeddleware';

//State
import { AppState } from "../../../../redux/reducers";
import { Contract } from '../../../../models/Entities/Contracts/Contract';
import { ContractAddendum } from '../../../../models/Entities/Contracts/ContractAddendum';


interface IProps {
  isOpen: boolean;
  openPanel: () => void;
  dismissPanel: () => void;
  ContractId: number;
  AddendumId: number;
}
  
interface ConnectedProps {
    // loading
    isLoading: boolean;
    isUpdating: boolean;
    isUpdatedSuccessfully: boolean;
    isLoadingSuccessfully: boolean;
    failOnUpdating: boolean;
    failOnLoading: boolean;
    
    // adding
    isAdding: boolean;
    isAddedSuccessfully: boolean;
    failOnAdding: boolean;

    // Ading Range
    AddRangeFinalized: boolean | undefined;
    
    error: ErrorType | undefined;
}
  
  interface DispatchProps {
    AddContractStageRange: typeof ContractStageStore.actionCreators.AddContractStageRange;
    AddContractStageCycleRange: typeof ContractStageCycleStore.actionCreators.AddContractStageCycleRange;
  }
  
  export type Props = IProps & ConnectedProps & DispatchProps;
  
  export const mapStateToProps = (state: AppState, ownProps: IProps) => {
    const CurrentContract = state.Contract?.list?.find((item: Contract) => item.id === ownProps.ContractId);
    const CurrentAddendum: ContractAddendum | undefined = CurrentContract?.addendums?.find((item: ContractAddendum) => item.id === ownProps.AddendumId);

    return ({

    // loading
    isLoading: CurrentAddendum?.isGettingContractStages || false,
    isLoadingSuccessfully: (!!CurrentAddendum && !CurrentAddendum?.isGettingContractStages && !CurrentAddendum?.FailGettingContractStages) || false,
    failOnLoading: CurrentAddendum?.FailGettingContractStages || false,

    // adding stage range
    isAdding: CurrentAddendum?.isSaving || false,
    isAddedSuccessfully: CurrentAddendum?.isSavedSuccessfully || false,
    failOnAdding: CurrentAddendum?.failOnSaving || false,

    // adding cycle
    isAddingCycle: false,
    isAddedSuccessfullyCycle: false,
    failOnAddingCycle: false,

    AddRangeFinalized: CurrentAddendum?.isSavedSuccessfully,


    error: CurrentAddendum?.error || CurrentAddendum?.ErrorGettingContractStages || undefined,
    
  });
  }
  
  export const mapDispatchToProps = {
    ...ContractStageStore.actionCreators,
    ...ContractStageCycleStore.actionCreators
  };